/**
 * @file AcceptTerms.jsx — /aceptar-terminos
 */
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { authService } from "../services/auth";
import AuthShell from "../components/AuthShell";
import { Button, Checkbox } from "../ui";

export default function AcceptTerms() {
  const navigate = useNavigate();
  const { handleAuthSuccess } = useAuth();
  const [termsChecked, setTermsChecked] = useState(false);
  const [privacyChecked, setPrivacyChecked] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const canProceed = termsChecked && privacyChecked;

  const handleAccept = async () => {
    setIsSubmitting(true);
    try {
      const res = await authService.acceptTerms();
      handleAuthSuccess(res.data);
      navigate("/", { replace: true });
    } catch {
      setIsSubmitting(false);
    }
  };

  return (
    <AuthShell
      title="Antes de continuar"
      subtitle="Revisa y acepta nuestros documentos legales para usar Consultto."
    >
      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        <Checkbox
          checked={termsChecked}
          onCheckedChange={(v) => setTermsChecked(!!v)}
          label={
            <span>
              Acepto los{" "}
              <a
                href="https://consultto.mx/terminos"
                target="_blank"
                rel="noreferrer"
                className="auth-link"
              >
                Términos y Condiciones
              </a>
            </span>
          }
        />
        <Checkbox
          checked={privacyChecked}
          onCheckedChange={(v) => setPrivacyChecked(!!v)}
          label={
            <span>
              Acepto el{" "}
              <a
                href="https://consultto.mx/aviso-de-privacidad"
                target="_blank"
                rel="noreferrer"
                className="auth-link"
              >
                Aviso de Privacidad
              </a>
            </span>
          }
        />
      </div>
      <Button
        size="lg"
        fullWidth
        onClick={handleAccept}
        disabled={!canProceed || isSubmitting}
        loading={isSubmitting}
      >
        Continuar
      </Button>
    </AuthShell>
  );
}
